import React from 'react';
export function Footer() {
  return <footer className="py-8 bg-navy-950 border-t border-white/5 text-center px-4" data-id="element-65">
      <p className="text-slate-500 text-sm" data-id="element-66">
        © {new Date().getFullYear()} Secretos de Promoción. Todos los derechos
        reservados.
      </p>
    </footer>;
}